import React from 'react';
import DangerAlert from '../common/alerts/DangerAlert';
import { RoutePaths } from 'Constants/Common';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from 'state/hooks';
import { getLocalPhone } from 'helpers/location';

const RepairRequestError = (): JSX.Element => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const location = useLocation();

    const onBackButtonClick = () => {
        navigate(RoutePaths.Home);
    };

    const repairRequestType = location.state?.repairRequestType;
    const country = useAppSelector((s) => s.site.country);
    const phone =
        getLocalPhone(country, { product: repairRequestType }) || t('phone');

    return (
        <>
            <div className='alert-container'>
                <DangerAlert
                    includeImage={false}
                    message={t('registration_error', { phone })}
                />
            </div>
            <div className='bottom-navigation'>
                <button
                    aria-label='back-button'
                    className='btn btn-secondary progress-button'
                    onClick={() => onBackButtonClick()}>
                    {t('back')}
                </button>
            </div>
        </>
    );
};

export default RepairRequestError;
